/** Ответ GET in-settings. Без сохранённой записи — дефолты формы без `id`. */
export interface PaymentSystemInSettings {
  id?: string;
  payment_system_id: string;
  payment_system_token?: string;
  currency_iso_code?: string;
  max_active_in_orders: number;
  /** Decimal-строка; `null` — без минимального эффективного баланса. */
  min_effective_balance: string | null;
}

/** Тело POST создания in-settings. */
export interface PaymentSystemInSettingsCreateRequest {
  max_active_in_orders: number;
  /** Число или decimal-строка; `null` — без минимального эффективного баланса. */
  min_effective_balance: number | string | null;
}

/** Тело PUT — полная замена полей существующей записи. */
export interface PaymentSystemInSettingsUpdateRequest {
  max_active_in_orders: number;
  min_effective_balance: number | string | null;
}

/** Дефолты формы, если запись in-settings ещё не создана (см. GET). */
export const PAYMENT_SYSTEM_IN_SETTINGS_FORM_DEFAULTS = {
  max_active_in_orders: 7,
  min_effective_balance: null,
} as const satisfies Pick<
  PaymentSystemInSettings,
  'max_active_in_orders' | 'min_effective_balance'
>;
